import { useState } from "react";
import { Button, ErrorMessage, Flex, ModalV2, Text, Textarea } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

export type HoldModalProps = {
  errorMessage: string | null;
  isSubmitting: boolean;
  onHide: () => void;
  onConfirm: (comment: string) => void;
};

export const HoldModal = ({
  errorMessage,
  isSubmitting,
  onHide,
  onConfirm,
}: HoldModalProps) => {
  const [comment, setComment] = useState("");

  return (
    <ModalV2
      show
      onHide={onHide}
      title="Put DDQ on hold?"
      size="small"
      data-testid="ddq-hold-modal"
    >
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.LARGE}>
          <Text variant="secondary-md">
            This will put the DDQ on hold until the task restarts. The due date will update to
            24 hours after the restart.
          </Text>
          <Textarea
            isFullWidth
            label="Leave a comment"
            isRequired
            placeholder="Add a reason for the hold"
            value={comment}
            onSetValue={setComment}
            data-testid="ddq-hold-comment"
          />
          {errorMessage && (
            <ErrorMessage data-testid="ddq-hold-error">{errorMessage}</ErrorMessage>
          )}
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex flexDirection="row" gap={SPACING.SMALL} justifyContent="flex-end">
          <Button variant="neutral" onClick={onHide} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            isLoading={isSubmitting}
            disabled={!comment.trim() || isSubmitting}
            onClick={() => onConfirm(comment)}
            data-testid="ddq-hold-confirm"
          >
            Hold DDQ
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
